import { Box, IconButton, Stack, Typography } from '@mui/material'
import Plus from '@assets/Notification/Plus.svg'
import Close from '@assets/Notification/CloseIcon.svg'

export default function TagChips({
  tags,
  onTagClick,
  selectedTags = [],
  onAddTag,
  onRemoveTag,
  disabledTags = [],
}: {
  tags: string[]
  onTagClick?: (tag: string) => void
  selectedTags?: string[]
  onAddTag?: () => void
  onRemoveTag?: (tag: string) => void
  disabledTags?: string[]
}) {
  return (
    <Stack direction="row" spacing={1} flexWrap="wrap" useFlexGap alignItems="center">
      {tags.map(tag => {
        const selected = selectedTags.includes(tag)
        const isDisabled = disabledTags.includes(tag)

        return (
          <Box
            key={tag}
            sx={{
              display: 'inline-flex',
              alignItems: 'center',
              gap: 0.5,
              border: '1px solid #EBEBF1',
              bgcolor: selected ? '#E3F5FF' : 'transparent',
              color: '#72A4EB',
              fontWeight: selected ? 700 : 400,
              px: 1.25,
              py: 0.25,
              borderRadius: '16px',
              lineHeight: 1,
              userSelect: 'none',
            }}
          >
            <Box
              component="span"
              onMouseDown={e => e.stopPropagation()}
              onClick={e => {
                e.stopPropagation()
                ;(onRemoveTag ?? onTagClick)?.(tag)
              }}
              sx={{ display: 'inline-flex', cursor: 'pointer' }}
            >
              <img src={Close} width={9} alt="remove" />
            </Box>

            <Typography
              component="span"
              onClick={e => {
                e.stopPropagation()
                if (!isDisabled) onTagClick?.(tag)
              }}
              sx={{ cursor: isDisabled ? 'default' : 'pointer' ,fontFamily: 'Rubik, sans-serif',}}
            >
              {tag}
            </Typography>
          </Box>
        )
      })}

      <IconButton
        size="small"
        onClick={e => {
          e.stopPropagation()
          onAddTag?.()
        }}
      >
        <img src={Plus} alt="plus" width={22} height={22} />
      </IconButton>
    </Stack>
  )
}
